<div>
  <div class="title">
    Outils
  </div>
  <div>
    <table mat-table matSort [dataSource]="toolsList">
      <ng-container matColumnDef="creationDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Date de création</th>
        <td mat-cell *matCellDef="let element">{{ element.creationDate }}</td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true;"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
</div>
<ms-activity-indicator-with-messages [fullWidth]="true" [isLoading]="isLoading" [overlay]="true"
                                     [messages]="messages"></ms-activity-indicator-with-messages>

